module.exports = __webpack_public_path__ + "static/media/snow_w_700.274c35b1.jpg";